export const VALID_FIELDS = [
  "code",
  "type",
  "pricing/price",
  "pricing/currency",
  "rental_pricing",
  "rental_pricing/currency",
  "contract_status",
  "rent_status",
  "floor/code",
  "floor/name",
  "tower/code",
  "tower/name",
  "contact/web",
  "building/type",
  "building/construction",
  "building/contruction_front",
  "building/construction_depth",
  "building/terrace",
  "building/total",
  "construction_allowed/unit",
  "construction_allowed/total",
  "features/rooms",
  "features/bathrooms",
  "media/featured_image/name",
  "media/featured_image/title",
  "media/featured_image/src",
  "media/featured_image/cloudinary_id",
  "media/plane_image/name",
  "media/plane_image/title",
  "media/plane_image/src",
  "media/plane_image/cloudinary_id",
  "miscellaneous/mapping_coords",
  "miscellaneous/mapping_coords_building",
  "amenities",
  "building/construction_depth_right",
  "building/construction_depth_left",
  "building/construction_back"
];
